import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaFunctionDefinition } from './TypedDefinition'

export const SchemaFunctionPlugin = createSchemaPlugin(
  'Schema.Function',
  SchemaFunctionDefinition
)
